import { render, staticRenderFns } from "./ResourceItemLiveInput.vue?vue&type=template&id=bac3a9be&"
import script from "./ResourceItemLiveInput.vue?vue&type=script&lang=ts&"
export * from "./ResourceItemLiveInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports